import { Auth } from '@angular/fire/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '@core/utils/firebase/firebase';
import { createMenusApi } from '../api/menus.api';

const menusApi = createMenusApi(auth as Auth);

export function useDeleteSiteMenusMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (siteId: number) => menusApi.deleteSiteMenus(siteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['menu-site-meal-plans'] });
    },
  });
}

export function useUpdateMenuMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { siteId: number; propertyId?: number; cycleStartDate?: string }) =>
      menusApi.updateMenu(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['menu-site-meal-plans'] });
      queryClient.invalidateQueries({ queryKey: ['menu-site-menu'] });
    },
  });
}

export function useSetDefaultMenuMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ siteId, diningRdMenuId }: { siteId: number; diningRdMenuId: number }) =>
      menusApi.setDefaultMenu(siteId, diningRdMenuId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['menu-site-meal-plans'] });
    },
  });
}

export function useSyncAllMenusMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { siteId: number; propertyId: number; cycleStartDate: string }) =>
      menusApi.syncAllMenus(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['menu-site-meal-plans'] });
      queryClient.invalidateQueries({ queryKey: ['menu-site-menu'] });
    },
  });
}

export function useSyncMenuMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { siteId: number; propertyId: number; cycleStartDate: string; diningRdMenuId?: number }) =>
      menusApi.syncMenu(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['menu-site-meal-plans'] });
      queryClient.invalidateQueries({ queryKey: ['menu-site-menu'] });
    },
  });
}
